import { graphql, useFragment } from "react-relay";
import { TodoListItemAssignedUsers_todo$key } from "./__generated__/TodoListItemAssignedUsers_todo.graphql";
import { notEmpty } from "../../utils";
import { ListItemAssignees } from "./ListItemAssignees";
import { TodoListItemFooterItem } from "./TodoListItemFooterItem";

export function TodoListItemAssignedUsers(props: {
  todo: TodoListItemAssignedUsers_todo$key;
  maxWidth?: number;
  currentEmployeeId: string | undefined;
}) {
  const todo = useFragment(
    graphql`
      fragment TodoListItemAssignedUsers_todo on Todo {
        assigned {
          assignedAt
          employee {
            id
            ...ListItemAssignees_employees
          }
        }
        assignedRoles {
          role {
            id
            ...ListItemAssignees_roles
          }
        }
      }
    `,
    props.todo
  );

  const employees = todo.assigned
    .filter((e) => e != null)
    .map((e) => e.employee)
    .filter(notEmpty);

  const roles = todo.assignedRoles
    .filter((r) => r != null && r.role != null)
    .map((r) => r.role);

  if (employees.length === 0 && roles.length === 0) {
    return null;
  }

  return (
    <TodoListItemFooterItem>
      <ListItemAssignees
        employees={employees}
        roles={roles}
        currentEmployeeId={props.currentEmployeeId}
        maxWidth={props.maxWidth}
      />
    </TodoListItemFooterItem>
  );
}
